import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  ViewChildren,
  HostListener,
  ElementRef,
  TemplateRef,
  Renderer2,
  Output,
  EventEmitter
} from '@angular/core';
import {UserGroupService} from 'src/app/core/services/user-group.service';
import {MatDialogRef, MatDialog, MatExpansionPanel, MatSelect} from '@angular/material';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {ReplaySubject, Subject, Subscription} from 'rxjs';
import {FormControl, NgForm} from '@angular/forms';
import {NotificationService} from 'src/app/core/services/notification.service';
import {first, map, takeUntil} from 'rxjs/operators';
import {DeactivationGuarded} from 'src/app/core/guards/confirm-deactivate.guard';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from 'src/app/core/services/api.service';
import {CommonService} from 'src/app/core/services/common.service';
import {AutoDepartmentFilterService} from 'src/app/core/services/auto-department-filter.service';
import {SCREEN_SIZE} from 'src/app/core/constants/screen-size';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {DepartmentService} from '../../../../../../../core/services/department.service';

@Component({
  selector: 'app-add-department',
  templateUrl: './add-department.component.html',
  styleUrls: ['./add-department.component.scss']
})
export class AddDepartmentComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  isShowResult = false;
  isSavingData = false;
  listErrorUser = [];
  countSuccess = 0;
  countError = 0;
  listFilterUserInDepartment = [];
  searchRepresentativeInput = '';
  inputUserValue: string;
  filteredUserOptions = [];
  dataSource: DocumentDataSource;
  firstEditLoaded = true;
  listUserInDepartment = [];
  userGroup = {
    id: null,
    code: '',
    name: '',
    description: '',
    listUserInDepartment: [],
    representativeIdString: '',
    departmentType: 1

  };
  change = false;
  featuresGroups: any;
  features: any;
  dataRole: any;
  subSignPermission: any;
  subManagerPermission: any;
  checkEscKey = false;
  checkAll = false;
  isFormChanging = false;
  formChangesSubscription: Subscription;
  grIdDefualt = {
    managerServiceTypeFeatureGroupId: '',
    signServiceTypeFeatureGroupId: ''
  };
  grId = this.grIdDefualt;
  nzCheckLoadingUser = false;
  isMultiCreateUserGroup = false;
  urlApi = '/users/group-user';
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('statusSelect', {static: false}) statusSelect: MatSelect;
  checkFocus = true;
  serviceTypes: comboBox[] = [];
  serviceTypePermission;
  showCreateSideError = false;
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  selectedDocumentTypeParent: { id: string, fullName: string, email?: string, filePath?: string };
  serviceTypesFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  displayItem = (x: any) => x !== null ? x.fullName !== undefined ? x.fullName + ' - ' + x.email : '' : '';
  columnDefinitions = [
    {def: 'fullName', showXS: true, showSM: true, showMD: true},
    {def: "action", showXS: true, showSM: true, showMD: true}
  ];

  displayedColumns: string[] = [];
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;

  columnDefinitionsResult = [
    {def: 'fullName', showXS: true, showSM: true, showMD: true},
    {def: 'description', showXS: true, showSM: true, showMD: true},
  ];
  displayedColumnsResult: string[] = [];

  @ViewChild('customPanel', {static: false}) panel: MatExpansionPanel;
  @ViewChild('togglePanelButton', {static: false}) togglePanelButton: ElementRef;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChildren('focusInput') focusInput;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event) {
    if (!this.checkEscKey) {
      this.onClickBtnCancel();
    }
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private apiService: ApiService,
    private el: ElementRef,
    private sv: UserGroupService,
    private dialogRef: MatDialogRef<AddDepartmentComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    public autoDepartmentFilterService: AutoDepartmentFilterService,
    private departmentService: DepartmentService,
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onClickBtnCancel();
    });
    this.getDisplayedColumns();
    this.getDisplayedColumnsResult();
  }

  canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;

  ngOnInit() {
    this.dataSource = new DocumentDataSource();
    this.apiService.addUrlToHandlingErrorRestApis(this.urlApi);

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

  }

  // Định dạng bảng trong form
  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }

    }
  }

  closeDialog(){
    this.dialogRef.close(true)
  }
  // Định dạng bảng trong kết quả trả về
  getDisplayedColumnsResult() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumnsResult = this.columnDefinitionsResult
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumnsResult = this.columnDefinitionsResult
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumnsResult = this.columnDefinitionsResult.map(cd => cd.def);
      }

    }
  }


  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.first.nativeElement.focus());
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
    this.apiService.removeUrlToHandlingErrorRestApis();
  }

  /**
   * Thêm phòng ban
   */
  onCreateGroup() {
    // Chặn khi ấn create liên tục
    if (this.isSavingData) {
      return;
    }
    this.isSavingData = true;
    //format lại data trong form trước khi gửi đi
    let listUser = [];
    this.listUserInDepartment.forEach(item => {
      listUser.push(item.id);
    });
    this.userGroup.listUserInDepartment = listUser;
    if (this.userGroup.representativeIdString === undefined) {
      this.userGroup.representativeIdString = null;
    }
    if (this.userGroup.representativeIdString !== null) {
      let isExist = false;
      this.listUserInDepartment.forEach(item => {
        if (item.id === this.userGroup.representativeIdString) {
          isExist = true;
        }
      });
      if (!isExist) {
        this.userGroup.representativeIdString = null;
      }
    }
    this.departmentService.createDepartment(this.userGroup).subscribe(res => {
      // console.log(res);
      if (res.success) {
        if (this.userGroup.listUserInDepartment.length === 0) {
          // Nếu thành công và không thêm user vào phòng ban thì đóng dialog
          this.toastr.success(this.message.getMessage('messages.add_department'));
          this.dialogRef.close(true);
        } else if (this.userGroup.listUserInDepartment.length > 0 && res.data.successCount === this.userGroup.listUserInDepartment.length) {
          // Nếu thành công và thêm được đầy đủ các user đã chọn vào phòng ban thì đóng dialog
          this.toastr.success(this.message.getMessage('messages.add_department'));
          this.dialogRef.close(true);
        } else if (this.userGroup.listUserInDepartment.length > 0 && res.data.successCount !== this.userGroup.listUserInDepartment.length) {
          // Nếu thành công nhưng có user đã thuộc phòng ban/bị xóa/bị khóa thì show bảng kết quả
          this.toastr.success(this.message.getMessage('messages.add_department'));
          this.isShowResult = true;
          this.countSuccess = res.data.successCount;
          this.countError = res.data.listUserError.length;
          this.listErrorUser = res.data.listUserError;
        }
      } else {
        this.isSavingData = false;
        this.toastr.error(res.message);
      }
    }, err => {
      this.isSavingData = false;
    });
  }

  /**
   * Close dialog
   */
  onClickBtnCancel() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  // Tìm kiếm user
  onChangeUserSignSearch(event): void {
    if (this.inputUserValue.trim().length > 0) {
      this.nzCheckLoadingUser = true;
      this.departmentService.getUserByFullNameOrEmail(this.inputUserValue.trim())
        .subscribe(result => {
          this.filteredUserOptions = result.data;
          if (this.listUserInDepartment.length > 0) {
            this.filteredUserOptions = this.filteredUserOptions.filter(item => {
              let isExist = false;
              this.listUserInDepartment.forEach(i => {
                if (item.id === i.id) {
                  isExist = true;
                }
              })
              if (!isExist) {
                return item;
              }
            });
          }
          this.nzCheckLoadingUser = false;
        }, error => {
          this.nzCheckLoadingUser = false;
        });
    } else {
      this.inputUserValue = '';
      this.filteredUserOptions = [];
    }
  }

    // Thêm user
    autocompleteUserSelected($event: any, model: any) {
      if ($event.isUserInput) {
        this.isFormChanging = true;
        const duplicateItem = this.listUserInDepartment.find(item => item.id === model.id);
        if (!duplicateItem || duplicateItem.length === 0) {
          model.email = model.fullName + ' - ' + model.email;
          this.listUserInDepartment.push(model);
          this.listFilterUserInDepartment = this.listUserInDepartment;
          this.searchRepresentativeInput = '';
          this.listFilterUserInDepartment.forEach(item => {
            item.isRepresentative = this.userGroup.representativeIdString === item.id;
            item.isDeleted = false;
          })
        }
      }
    }

  // Xóa user
  deleteUser(username) {
    this.isFormChanging = true;
    this.listUserInDepartment = this.listUserInDepartment.filter(v => v.id !== username.id);
    this.listFilterUserInDepartment = this.listUserInDepartment;
    if (username.id === this.userGroup.representativeIdString) {
      this.userGroup.representativeIdString = null;
    }
  }

    // Lọc user khi chọn người đại diện phòng ban
    onInputChange(event: any) {
      const searchInput = event.target.value.toLowerCase();
      this.listFilterUserInDepartment = this.listUserInDepartment.filter((item) => {
        const prov = item.email.toLowerCase();
        if (prov.includes(searchInput)) {
          item.isDeleted = false;
        } else {
          item.isDeleted = true;
        }
        return item;
      });
    }

    //set representative
    setRepresentative(element){
      this.userGroup.representativeIdString = element.id
      this.listFilterUserInDepartment.forEach(item => {
        item.isRepresentative = this.userGroup.representativeIdString === item.id;
      })
    }
}


export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  constructor() {
    super();
  }


  setData(data: Document[]) {
    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
  }
  representativeSelected(data) {
  }


}
